import React, { useMemo, Fragment, useContext } from 'react';
import classNames from 'classnames';
import getFullStateName from '../../utils/getFullStateName';
import slugify from '../../utils/slugify';
import { Context } from '../../context/AppContext';
import config from '../../../src/client/config';
import JsonSchema from '../JsonSchema';
import CustomTag from '../CustomTag';
import './styles.css';

const { urlRoot } = config;

const Breadcrumbs = ({ data }) => {
  const {
    media: { desktop },
  } = useContext(Context);

  const formatLink = value => {
    if (value === '/') return value;
    return /^\/(.*)+$/.test(value) ? value : `/${value}`;
  };

  const formatLinks = items =>
    [...new Map(items.map(item => [item.breadcrumb, item])).values()].reduce(
      (aggregate = [], { url_slug: urlSlug, breadcrumb, url, tag }) => {
        const item = [...aggregate].pop();
        const link =
          url ||
          (item && item.urlSlug && urlSlug && item.url
            ? `${item.url}/${slugify(breadcrumb)}`
            : urlSlug);
        return aggregate.concat({
          urlSlug,
          url: link,
          tag,
          breadcrumb: getFullStateName(breadcrumb) || breadcrumb,
        });
      },
      []
    );

  const links = useMemo(() => formatLinks(data), [data]);

  const jsonSchema = value => {
    const schema = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [],
    };
    let count = 0;
    schema.itemListElement = value.reduce((sum, { breadcrumb, url }) => {
      if (breadcrumb && url)
        return sum.concat({
          '@type': 'ListItem',
          position: count++,
          name: breadcrumb,
          item: url ? `${urlRoot}/${url.replace(/^\//, '')}` : null,
        });
      return sum;
    }, []);
    return JsonSchema(schema);
  };

  if (!links) return '';

  return (
    <Fragment>
      {jsonSchema(links)}
      <div
        className={classNames('Breadcrumbs__root', {
          'Breadcrumbs__root--tabletMobile': !desktop,
        })}
      >
        {links.map(({ breadcrumb: name, url, tag = 'div' }, key) => (
          <Fragment key={name + key}>
            {url ? (
              <a href={formatLink(url)} className="Breadcrumbs__item">
                {name}
              </a>
            ) : (
              <CustomTag tag={tag} className="Breadcrumbs__item">
                {name}
              </CustomTag>
            )}

            {key !== links.length - 1 && (
              <div className="Breadcrumbs__divider">
                <span className="icon-generalcaretrightsmall" />
              </div>
            )}
          </Fragment>
        ))}
      </div>
    </Fragment>
  );
};

export default Breadcrumbs;
